import { styles } from './styles'
import HelpOutline from '@mui/icons-material/HelpOutline'
import LinkOff from '@mui/icons-material/LinkOff'
import Circle from '@mui/icons-material/FiberManualRecord'
import { AdCreativeStatus } from 'common/api/v1/types'
import Round from '@mui/icons-material/FiberManualRecordOutlined'

export const adCreativeIndicateStatusText = (status?: AdCreativeStatus) => {
  if (status === undefined) {
    return 'Unknown'
  }

  switch (status) {
    case AdCreativeStatus.active:
      return 'Active'
    case AdCreativeStatus.pending:
      return 'Pending'
    case AdCreativeStatus.probeFailed:
      return 'Probe Failed'
    case AdCreativeStatus.thumbnailFailed:
      return 'Thumbnail Failed'
    case AdCreativeStatus.uploadFailed:
      return 'Upload Failed'
    default:
      return 'Unknown'
  }
}

export const AdCreativeIndicatorIcon = ({ status }: { status?: AdCreativeStatus }) => {
  if (status === undefined) {
    return <Round sx={styles.success} />
  }

  switch (status) {
    case AdCreativeStatus.active:
      return <Circle sx={styles.success} />
    case AdCreativeStatus.pending:
      return <Round sx={styles.success} />
    case AdCreativeStatus.probeFailed:
      return <Circle sx={styles.error} />
    case AdCreativeStatus.thumbnailFailed:
      return <Circle sx={styles.warning} />
    case AdCreativeStatus.uploadFailed:
      return <LinkOff sx={styles.error} />
    default:
      return <HelpOutline sx={{ ...styles.warning }} />
  }
}
